import React from 'react';
import { Button, Typography, capitalize } from '@mui/material';
import { useIntl, FormattedMessage } from 'react-intl';

import Dialog from '../DesignSystem/Dialog';
import useCookieSettings from '../../Hooks/useCookieSettings';

function AuthCookieModal({ provider, open, setOpen }: any) {
  const intl = useIntl();
  const { settings, update } = useCookieSettings();

  const dialogTitle = intl.formatMessage({
    id: `SETTINGS.COOKIES.${provider.toUpperCase()}.TITLE`,
  });

  const dialogContent = intl.formatMessage(
    { id: 'COOKIES_SETTINGS.SSO_AUTH_MODAL.CONTENT' },
    { providerName: capitalize(provider) },
  );

  const onClose = () => {
    setOpen(false);
  };

  const enableCookie = () => {
    update({ ...settings, [provider]: true });
    onClose();
  };

  return (
    <Dialog
      open={open}
      id="auth-cookie"
      label={dialogTitle}
      title={dialogTitle}
      onClose={onClose}
      variant="small"
      dismissible={false}
      actions={
        <>
          <Button variant="outlined" size="large" onClick={onClose} color="primary">
            <FormattedMessage id="BUTTONS.CANCEL" />
          </Button>
          <Button variant="contained" size="large" onClick={enableCookie} color="primary">
            <FormattedMessage id="BUTTONS.CONFIRM" />
          </Button>
        </>
      }
    >
      <Typography variant="body1">{dialogContent}</Typography>
    </Dialog>
  );
}

export default AuthCookieModal;
